import React from 'react';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';
import { ServiceResponse } from '@/api/bol';

export interface ServiceDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  service: ServiceResponse | null;
}

export const ServiceDeleteDialog: React.FC<ServiceDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  service
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="service"
      itemId={service?.id || ''}
    />
  );
};